type Props = {
  data?: [any] | { [key: string]: any };
  callback?: () => void;
  name?: string;
};

export const exportToJsonFile = ({ data, callback, name }: Props) => {
  const jsonString = `data:text/json;chatset=utf-8,${encodeURIComponent(
    JSON.stringify(data),
  )}`;
  const link = document.createElement("a");
  link.href = jsonString;
  link.download = `${name || "data"}.json`;

  link.click();

  callback && callback();
};
